// @flow
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import * as actions from '../actions'
import EditAM from '../components/AdminAMList/EditAM'

import type {MapStateToProps, MapDispatchToProps} from 'react-redux'
import type {State, Action} from 'modules/Common/types'
import type {Match, RouterHistory} from 'react-router'
import type {AdminState} from '../types/index'

export type OwnProps = {
  match: ?Match,
  history: RouterHistory,
  location: {
    pathname: string
  }
};

export type StateProps = {
  accountManagers: $PropertyType<AdminState, 'accountManagers'>,
  isLoadingAccountManagers: $PropertyType<AdminState, 'isLoadingAccountManagers'>,
  error: $PropertyType<AdminState, 'error'>,
  isLoadingCompaniesSuggestion: $PropertyType<AdminState, 'isLoadingCompaniesSuggestion'>,
  companiesSuggestion: $PropertyType<AdminState, 'companiesSuggestion'>,
  companies: $PropertyType<AdminState, 'companies'>,
  roleList: $PropertyType<AdminState, 'roleList'>
};

export type DispatchProps = {
  getAccountManagers: $PropertyType<typeof actions, 'getAccountManagers'>,
  addOrUpdateAM: $PropertyType<typeof actions, 'addOrUpdateAM'>,
  getCompaniesSuggestion: $PropertyType<typeof actions, 'getCompaniesSuggestion'>,
  getCompanies: $PropertyType<typeof actions, 'getCompanies'>,
  getRolesList: $PropertyType<typeof actions, 'getRolesList'>
};

const mapStateToProps: MapStateToProps<State, OwnProps, StateProps> = (state: State) => {
  return {
    accountManagers: state.admin.accountManagers,
    error: state.admin.error,
    isLoadingAccountManagers: state.admin.isLoadingAccountManagers,
    isLoadingCompaniesSuggestion: state.admin.isLoadingCompaniesSuggestion,
    companiesSuggestion: state.admin.companiesSuggestion,
    companies: state.admin.companies,
    roleList: state.admin.roleList
  }
}
const mapDispatchToProps: MapDispatchToProps<Action<*>, OwnProps, DispatchProps> = dispatch => bindActionCreators({...actions}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(EditAM)
